// src/redux/reducers/index.js
import { combineReducers } from "redux";
import programCategoryReducer from "./programCategoryReducer";
import userReducer from "./userReducer"; // Import the userReducer
import heroUserReducer from "./heroUserReducer"; // Import hero user reducer
import learnerReducer from "./learnerReducer"; // Import learner reducer
import registrationReducer from "./registrationReducer";
import learningContentReducer from "./learningContentReducer";
import lastWriteReducer from "./lastWriteReducer";
import contractorFormReducer from "./contractorFormReducer"; // Import contractor form reducer
import supplierFormReducer from "./supplierFormReducer"; // Import supplier form reducer
import unitContextReducer from "./unitContextReducer";
import baselineAssessmentReducer from "./baselineAssessmentReducer";
import fleetCoreReducer from "./fleetCoreReducer";
import funderProgressCacheReducer from "./funderProgressCacheReducer";
import accessReducer from "./accessReducer";
import learnerDashboardReducer from "../../unity/learner/state/learnerDashboardReducer";
import facilitatorWorkspaceReducer from "../../unity/facilitator/state/facilitatorWorkspaceReducer";

const rootReducer = combineReducers({
  access: accessReducer,
  unityLearner: learnerDashboardReducer,
  unityFacilitator: facilitatorWorkspaceReducer,
  category: programCategoryReducer,
  user: userReducer,
  heroUser: heroUserReducer,
  learner: learnerReducer,
  registration: registrationReducer,
  learningContent: learningContentReducer,
  lastWrite: lastWriteReducer,
  contractorForm: contractorFormReducer,
  supplierForm: supplierFormReducer,
  unitContext: unitContextReducer,
  baselineAssessment: baselineAssessmentReducer,
  fleetCore: fleetCoreReducer,
  funderProgressCache: funderProgressCacheReducer,
});

export default rootReducer;
